export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9568.1d1c4ebd.jpg";